<template>
  <div class="shu">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png" style="margin-right:10px" alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>工作流</el-breadcrumb-item>
          <el-breadcrumb-item>图片展示</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div class="refresh">
        <img :class="isRefresh ?'imgmove':''" width="16px" height="16px" src="@/assets/house/refresh.png" alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>图片展示</h4>
      </div>

      <div class="kabj">
        <div v-if="powersObj.browseWebsiteInfo || powersObj.manageWebsiteInfo" :class="isSimple ? 'ka simpleka' : 'ka' " @click="$router.push('/workflow/picShow')">
          <img width="103" height="103" src="@/assets/platform/7.png" alt="">
          <div class="text">
            <p>图片展示列表</p>
            <p style="margin-top: 15px;font-size:14px;color:rgba(52,52,52,1);">您可以通过此列表查看所有草稿、已发布、定时发布的图片展示内容。</p>
          </div>
        </div>

        <div v-if="powersObj.browseWebsiteCarousel || powersObj.manageWebsiteCarousel" :class="isSimple ? 'ka simpleka' : 'ka' " @click="$router.push('/workflow/rotationSet')">
          <img width="103" height="103" src="@/assets/platform/8.png" alt="">
          <div class="text">
            <p>轮播图设置</p>
            <p style="margin-top: 15px;font-size:14px;color:rgba(52,52,52,1);">您可以通过此工作流程对站点轮播图、频道轮播图进行设置。</p>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getDate,formatConversion } from "@/plugins/getdate";
import { powersObj } from "@/constants/powers";
export default {

  data() {
    return {
      isRefresh:false,
      powersObj,
    };
  },
  methods: {
    
  },
  created() {

  },
  beforeDestroy(){ 
     
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./piccontribution.scss";

</style>
